import { Multiselect, Select } from 'AWS-UI-Components-React';
import React from 'react';
import { REPORT_TYPE } from '../../constants/report_type';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';
import { Currency } from '../const/dropdown_elements';

export class CurrencyButton extends React.Component {
  getOptions = () => {
    let options = [];
    for (let currency of Currency) {
      if (this.props.report.toUpperCase() === REPORT_TYPE.BENCHMARK && currency.id !== 'LOCAL') {
        continue;
      }
      if (this.props.excludeLocal && currency.id === 'LOCAL') {
        continue;
      }
      options.push(currency);
    }
    return options;
  }

  render() {
    return (
      <div className={AccuracyButtonNewStyle}>
        <b> {this.props.text} </b>
        <Select
          options={this.getOptions()}
          selectedId={this.props.selectedId}
          placeholder={this.props.text}
          onChange={this.props.onChange}
          data-cy={this.props['data-cy']}
        />
      </div>
    );
  }

  static defaultProps = {
    'data-cy': 'currency-button'
  }
}


// WEBPACK FOOTER //
// ./src/components/buttons/currency_button.jsx